import './app-header.css';
import React, { Component } from 'react';
import { Auth } from '../../services';
import { APP_CONST } from '../../constants';
import { GeckoBtn } from '../../components';
import { $state } from '../../router/';

export class AppHeader extends Component {
    logout() {
        return $state.go('logout');
    }

    render() {
    	return (
    		<div className="app-header">
                <div className="row app-header-inner">
    			     <div className="col logo d-flex flex-row align-items-center">
                        <img src="/images/gecko-engage-color.svg" alt="Gecko" height="22" />Account
                    </div>

                    <div className="col d-flex flex-row align-items-center justify-content-end action">
                        <HeaderButtons buttons={this.props.buttons} />
                        <GeckoBtn 
                            name="Logout" 
                            type={APP_CONST.BTN_TYPE_DANGER} 
                            handler={this.logout.bind(this)}
                            icon={'sign-out-alt'}
                            className="float-left"
                        />
                    </div>
                </div>
    		</div>
    	);
    }
}

AppHeader.defaultProps = {
    buttons: null,
}

const HeaderButtons = (props) => {
    if (!props.buttons || props.buttons.length === 0) return null;

    return (
        <div className="AppHeader-buttons">
            {props.buttons.map((button) => {
                return <GeckoBtn style={{marginRight: '20px'}} {...button}/>;
            })}
        </div>
    )
}

HeaderButtons.defaultProps = {
    buttons: null,
}

export default AppHeader;